import {
  Component, Input, Output, ViewEncapsulation, ViewChild, Renderer2, ElementRef, ChangeDetectorRef
} from '@angular/core';

import { FormsModule, FormGroup, FormControl, Validators, NgForm, AbstractControl }
  from '@angular/forms';

import { Session_PreQuestionNumberModel } from "../Models/Model/Session_PreQuestionNumberModel";
import { aspNetControl } from '../Enum/ASPNetControl';
import { typeInfo } from '../Enum/TypeInfo';
import { formService } from '../Service/formService';
import { MaskedTextBoxComponent } from '@progress/kendo-angular-inputs';
import { each as _each } from 'lodash-es'
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns';
import dayjs from 'dayjs'
import { StatesComponent } from '../State/States.component'
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { KENDO_INPUTS } from "@progress/kendo-angular-inputs";
import { KENDO_DATEINPUTS } from "@progress/kendo-angular-dateinputs";
import { CommonModule, CurrencyPipe, DatePipe, DecimalPipe } from '@angular/common';

@Component({
  selector: 'controls',
  templateUrl: 'controls.component.html',
  styleUrls: ['controls.component.css', '../../styles.scss'],
  encapsulation: ViewEncapsulation.None,
  exportAs: 'ngModel',
  imports: [StatesComponent, KENDO_INPUTS, KENDO_DATEINPUTS, FormsModule, DecimalPipe,
    CurrencyPipe, DatePipe, CommonModule]
})
export class ControlsComponent {
  @ViewChild(NgForm, { static: false }) form: NgForm | null | undefined;
  @ViewChild('kendoMaskedTextbox', { static: false }) kendoMaskedTextbox: MaskedTextBoxComponent | null | undefined;
  @ViewChild('inputMaskedTextbox', { static: false }) inputMaskedTextbox: ElementRef | null | undefined;
  @ViewChild("dropdownlist") public dropdownlist: DropDownListComponent | null | undefined;

  private RequiredAnswerMessage: string = '';
  public ASPNetControl = aspNetControl;
  public TypeInfo = typeInfo;
  public _orderList: Array<string> = new Array<string>();
  public zipcodeMask = '00000';
  public telephoneMask = '(999) 000-0000';

  public get orderList() {
    if (this._orderList.length === 0) {
      this._orderList.push('');
    }

    return this._orderList;
  }

  @Input() item: any;


  sanitize(value: string): SafeHtml {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }

  hasValue(value: string): boolean {
    var html = this.AriaLabel(value);
    return html.replace(/\u00A0/g, '').replace('&nbsp;', '').trim().length > 0;
  }

  constructor(private FormService: formService, private cdRef: ChangeDetectorRef, private sanitized: DomSanitizer) {
  }

  AriaLabel = (html: string) => {
      const temp = document.createElement('div');
      temp.innerHTML = html;
      return temp.textContent || temp.innerText || '';
  }

  checkOrderList = () => {
    let addDefault: boolean = true;
    this.item.value = '';
    _each(this._orderList, (item: string) => {
      if (item.length === 0) {
        addDefault = false;
      }
      else {
        if (this.item.value.length > 0) {
          this.item.value = this.item.value + '\n';          
        }
        this.item.value = this.item.value + item;
      }
    });
    if (addDefault) {
      this._orderList.push('');
    }
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  //Calculate the width
  width = (size: number) => {
    if (size * 9 + 32 > screen.availWidth) {
      return '100%';
    }
    else {
      return size * 9 + 32;
    }
  }

  //Convert string to number
  ParseInt = (value: any) => {
    if (parseInt(value).toString() !== 'NaN') {
      return parseInt(value);
    }
    else {
      return null;
    }
  }

  //Convert string to number
  ParseDec = (value: any) => {
    if (parseFloat(value).toString() !== 'NaN') {
      return parseFloat(value);
    }
    else {
      return null;
    }
  }

  controlName = (item: Session_PreQuestionNumberModel) => {
    if (item.aspNetControlId === this.ASPNetControl.TextBox) {
      var element = document.querySelector('#' + "txtBoxId" + item.genID);
      if (element) {        
        if (element.tagName.toLowerCase().includes('kendo')) {
          var input = element.querySelector("input");
          if (input) {
            return input.id;
          }
        }
      }
      return "txtBoxId" + item.genID;
    }
    if (item.aspNetControlId === this.ASPNetControl.User_Defined_Amount) {
      var element = document.querySelector('#' + "udaId" + item.genID);
      if (element) {
        if (element.tagName.toLowerCase().includes('kendo')) {
          var input = element.querySelector("input");
          if (input) {
            return input.id;
          }
        }
      }
      return "udaId" + item.genID;
    }
    
    if (item.aspNetControlId === this.ASPNetControl.DropDownList) {
      return "ddlId" + item.genID;
    }
    if (item.aspNetControlId === this.ASPNetControl.CheckBoxList) {
      return "chkBoxId" + item.genID;
    }
    if (item.aspNetControlId === this.ASPNetControl.User_Defined_Amount) {
      return "udaId" + item.genID;
    }
    if (item.aspNetControlId === this.ASPNetControl.States_List) {
      return "state" + item.genID;
    }
  }

  //Get the selected item value
  selectItemValue = (item: Session_PreQuestionNumberModel) => {
    return this.FormService.selectItemValue(item);
  }

  isValid() {
    /* THIS IS DONE SINCE A DISABLED CONTROL HAVE A VALID VALUE OF FALSE AND INVALID VALUE OF FALSE*/
    if (this.item?.value != null) {
      const value = String(this.item.value).trim();

      if (
        this.item.typeId === this.TypeInfo.Phone_Number &&
        value.length !== 10
      ) {
        return false;
      }
    }

    if (this.form) {
      return !this.form.invalid;
    }

    return true;
  }

  //Display error messages
  errorMessages = () => {
    let messsage = this.FormService.errorMessage(this.item);
    if (messsage !== null) {
      return messsage;
    }
    else {
      return '';
    }
  }

  //Determine if the radio button is selected
  isRadioButtonItemSelected = (selectedValue: any, genId: any) => {
    if (selectedValue) {
      return selectedValue.toString() === genId.toString();
    }
    else {
      return false;
    }
  }

  //Get the width of drop down list item
  popupWidth = (array: Array<any>, property: string) => {
    return this.FormService.popupWidth(array, property);
  }

  //get/set the value
  get value() {
    if (this.item.value && this.item.typeId == 2) {
      if (!(this.item.value instanceof Date)) {
        this.item.value = new Date(this.item.value);
      }
    }
    return this.item.value;
  }
  set value(val: any) {
    this.item.value = val;
  }

  ngAfterViewChecked() {
    //Alter the class of the kendo masked text box
    if (this.kendoMaskedTextbox && this.inputMaskedTextbox) {
      this.kendoMaskedTextbox.input.nativeElement.className = this.inputMaskedTextbox.nativeElement.className;
    }
    //Validate the phone number
    if (this.item.typeId === this.TypeInfo.Phone_Number) {
      if (this.item.value) {        
        this.item.valid = this.item.value.toString().trim().length === 10;
      }
    }
    this.cdRef.detectChanges();
  }

  //Convert to number
  ToString(data: any): string {
    if (data != null && data != undefined && data) {
      return data.toString();
    }
    return '';
  }

  //Convert to number
  ToNumber(data: any): number {
    return Number(data);
  }

  //Convert to date
  ToDate(data: any): Date {
    return new Date(data);
  }

  onChangeDate(item: any) {
    if (dayjs(item.value).isValid()) {
      var d = new Date(item.value);
      if (d.getFullYear() < 1000) {
        if (d.getFullYear() < 40) {
          d.setFullYear(d.getFullYear() + 2000, d.getMonth(), d.getDay());
        }
        else {
          d.setFullYear(d.getFullYear() + 1900, d.getMonth(), d.getDay());
        }
      }
      item.value = d;
    }
  }

  selectItem(item: any, args: any) {
    if (args.target.value !== '') {
      item.value = parseInt(args.target.value);
    }
    else {
      item.value = null;
    }
  }

}
